import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Transition as _Transition, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25a6b817"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "modal-body" }

import { onUnmounted, watch } from "vue";
import CustomCard from "./CustomCard.vue";
import CustomIconButton from "./CustomIconButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomModal',
  props: {
  show: {
    type: Boolean,
    required: true,
  },
  enterFrom: {
    type: String,
    default: "bottom",
  },
  fullHeight: {
    type: Boolean,
    default: false,
  },
  header: {
    type: String,
    default: "",
  },
  unRemoveable: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



watch(
  () => props.show,
  () => {
    if (props.show) {
      window.scrollTo(0, 0);
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }
);

onUnmounted(() => {
  document.body.classList.remove("modal-open");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      name: props.enterFrom
    }, {
      default: _withCtx(() => [
        (props.show)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['modal-underlay', props.enterFrom])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(['modal', __props.fullHeight ? 'full-height' : ''])
              }, [
                _createVNode(CustomCard, { class: "card" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _renderSlot(_ctx.$slots, "header")
                        ]),
                        (!__props.unRemoveable)
                          ? (_openBlock(), _createBlock(CustomIconButton, {
                              key: 0,
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClose')))
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _renderSlot(_ctx.$slots, "body")
                      ])
                    ])
                  ]),
                  _: 3
                })
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["name"])
  ]))
}
}

})